module.exports = __webpack_public_path__ + "img/l_electron.db37b010.svg";